import React, { useEffect, useRef, useState } from "react";
import InsideHeader from "../../../components/InsideHeader";
import svg76 from "../../../assets/svg/svg76.svg";
import svg77 from "../../../assets/svg/svg77.svg";
import svg27 from "../../../assets/svg/svg27.svg";
import { Checkbox, Divider, Dropdown, Form, Table, Tag } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../../features/dropdown/dropdownSlice";
import Search from "../../../components/Search";
import moment from "moment";
import {
  setActiveObj,
  setViewMode,
} from "../../../features/folder/folderSlice";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import CardLoading from "../../../components/CardLoading";
import { cashConverter, formatText } from "../../../utils";
import eyeSvg from "../../../assets/svg/eye.svg";
import svg82 from "../../../assets/svg/svg82.svg";
import svg98 from "../../../assets/svg/svg98.svg";
import ConfirmModal from "../../../components/ConfirmModal";

function JobsTable() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v1/jobs/getAll";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[url] || [],
    count: state.dropdown.count[url] || 0,
  }));
  const { saving } = useSelector((state) => state.save);

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const [openDelete, setOpenDelete] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const handleOpenDelete = async (item) => {
    await setSelectedItem(item);
    await setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v1/jobs",
        jobId: prodd?.jobId,
        jobAdvertStatus: selectedItem,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        jobTitle: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "job", data: prodd }));
    await dispatch(setViewMode(true));
    await navigate("/recruitment/job-add-list");
  };
  const handleDisable = () => {};
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "job", data: {} }));
    await dispatch(setViewMode(false));
    await navigate("/recruitment/job-add-list");
  };
  const handleView = async () => {
    await dispatch(setActiveObj({ key: "job", data: prodd }));
    await dispatch(setViewMode(true));
    await navigate("/recruitment/job-add-list");
  };
  const handleViewName = async (item) => {
    await dispatch(setActiveObj({ key: "job", data: item }));
    await dispatch(setViewMode(true));
    await navigate("/recruitment/job-add-list");
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          className="flex gap-x-[.75rem] items-center py-[.5rem]"
          onClick={handleEdit}
        >
          <img src={eyeSvg} alt="eyeSvg" className="w-4 h-4" /> View
        </Link>
      ),
    },
    {
      key: "divider-1",
      type: "divider",
    },
    {
      key: "2",
      label: (
        <Link
          className="flex gap-x-[.75rem] items-center py-[.5rem]"
          onClick={() => handleOpenDelete("ARCHIEVE")}
        >
          <img src={svg98} alt="svg98" className="w-4 h-4" />
          <span className="whitespace-nowrap">Archieve</span>
        </Link>
      ),
    },
    {
      key: "divider-2",
      type: "divider",
    },
    {
      key: "3",
      label:
        prodd?.jobAdvertStatus === "PUBLISH" ? (
          <Link
            className="flex gap-x-[.75rem] items-center py-[.5rem]"
            onClick={() => handleOpenDelete("END_PROCESS")}
          >
            <img src={svg82} alt="svg82" className="w-4 h-4" /> End Recruitment
            Process
          </Link>
        ) : null,
    },
  ];
  const plainOptions = [
    { value: "PUBLISH", label: "Published" },
    { value: "RE_ADVERTISE", label: "Re-advertised" },
    { value: "ARCHIEVE", label: "Archived" },
    { value: "CANCEL", label: "Cancelled" },
  ];

  const [selectedFilters, setSelectedFilters] = useState([]);
  const [popoverVisible, setPopoverVisible] = useState(false);

  const handleRemoveFilter = (removedStatus) => (e) => {
    console.log("clicked");
    e.preventDefault();
    setSelectedFilters((prev) =>
      prev?.filter((status) => status !== removedStatus)
    );
  };
  const onChangeFilter = (checkedValues) => {
    setSelectedFilters(checkedValues);
  };

  const handleApply = async () => {
    await setPopoverVisible(false);
  };

  const handleReset = async () => {
    await setSelectedFilters([]);
    await setPopoverVisible(false);
  };
  const filterOverlay = (
    <div className="w-[15.6875rem] p-[1.5rem] bg-white rounded-[.5rem] shadow-[0_0_13.9px_0_rgba(0,0,0,0.08)]">
      <p className="font-semibold">Select Filter</p>
      <Checkbox.Group
        options={plainOptions}
        value={selectedFilters}
        onChange={onChangeFilter}
        className="filter-checkbox"
      />

      <Divider />

      <div className="flex justify-center gap-[1.5rem] mt-3 font-dmSans text-[.875rem] font-[400]">
        <span className="text-[#FDB505]  cursor-pointer" onClick={handleReset}>
          Reset
        </span>
        <span className="text-[#C62130]  cursor-pointer" onClick={handleApply}>
          Apply
        </span>
      </div>
    </div>
  );

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "3%",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Job Title",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.jobTitle}
          </div>
        );
      },
      sorter: (a, b) => a.jobTitle.localeCompare(b.jobTitle),
    },

    {
      title: "Job Location",
      dataIndex: "jobCity",
      sorter: (a, b) => a.jobCity.localeCompare(b.jobCity),
    },
    {
      title: "Vacancy Count",
      dataIndex: "jobVacancyCount",
      sorter: (a, b) => a.jobVacancyCount.localeCompare(b.jobVacancyCount),
    },
    {
      title: "Salary",
      dataIndex: "jobGrossPay",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.jobGrossPay.localeCompare(b.jobGrossPay),
    },

    {
      title: "Advert Start Date",
      dataIndex: "jobAdvertStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.jobAdvertStartDate).valueOf() -
        moment(b.jobAdvertStartDate).valueOf(),
    },
    {
      title: "Advert End Date",
      dataIndex: "jobAdvertEndDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.jobAdvertEndDate).valueOf() -
        moment(b.jobAdvertEndDate).valueOf(),
    },
    {
      title: "Advert Status",
      dataIndex: "jobAdvertStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          PUBLISHED: "#569D6E",
          DRAFT: "#706F6F",
        };

        return (
          <div
            className="bg-[#E8EEED] inline-block rounded-[8px] px-[1rem] py-[.25rem] w-auto !font-[500] !text-[1rem]"
            style={{
              color: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        statuses: selectedFilters,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, [selectedFilters]);

  const urlExperience = "v1/ap/job-experience";
  const urlQualification = "v1/ap/qualification/getAllQualifications";
  const urlStudy = "v1/ap/study-area";
  const urlJobType = "v1/api/job-types";
  const urlOccupation = "v1/ap/occupation/occupations";
  const urlTerms = "v1/ap/terms-of-employment/terms-of-employment";
  const urlStyles = "v1/ap/work-style/work-styles";
  const urlProcess = "v1/ap/recruitment-setup/fetch";

  useEffect(() => {
    dispatch(fetchData({ url: urlExperience }));
    dispatch(fetchData({ url: urlQualification }));
    dispatch(fetchData({ url: urlStudy }));
    dispatch(fetchData({ url: urlJobType }));
    dispatch(fetchData({ url: urlOccupation }));
    dispatch(fetchData({ url: urlTerms }));
    dispatch(fetchData({ url: urlStyles }));
    dispatch(fetchData({ url: urlProcess }));
  }, []);

  if (loading && !searchInput && !selectedFilters) return <CardLoading />;
  return (
    <>
      <div className="w-full h-full overflow-y-scroll">
        <InsideHeader
          title="Job Adverts"
          subtitle="Advertise your job vacancies"
          back={false}
        />

        <div className="white_card mt-[2.5rem] flex-1 min-h-[70vh] ">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-[1rem]">
              <div className="lg:w-[35.125rem] w-auto ">
                <Search
                  searchInput={searchInput}
                  handleSearch={handleSearch}
                  text={"Search ..."}
                />
              </div>

              <>
                <div className="">
                  <Dropdown
                    overlay={filterOverlay}
                    trigger={["click"]}
                    placement="bottom"
                    open={popoverVisible}
                    onOpenChange={(visible) => setPopoverVisible(visible)}
                  >
                    <div className="flex items-center cursor-pointer text-[#706F6F] text-[.875rem] font-[400] font-dmSans">
                      <span>Filter</span>
                      <img src={svg77} alt="filter icon" className="ml-1" />
                    </div>
                  </Dropdown>
                </div>
              </>
            </div>

            <div className="w-[120px]">
              <button onClick={() => handleAdd()} className="cstm-btn">
                <img src={svg76} alt="svg76" /> <span className="">New</span>
              </button>
            </div>
          </div>
          <div className="mt-[1.25rem]">
            {selectedFilters &&
              selectedFilters?.map((status) => {
                const matchedOption = plainOptions?.find(
                  (opt) => opt?.value === status
                );
                const label = matchedOption ? matchedOption.label : status;

                const statusColors = {
                  Published: "#569D6E",
                  "Re-advertised": "#DAA520",
                  Archived: "#706F6F",
                  Cancelled: "#FDB505",
                };

                return (
                  <Tag
                    closeIcon
                    onClose={handleRemoveFilter(status)}
                    className="inline-block w-fit max-w-max px-[.5rem] py-[.25rem] bg-[#E8EEED]
                  rounded-[2.1875rem] text-[.75rem] font-[400]"
                    style={{ color: statusColors[label] || "#000" }}
                  >
                    {label}
                  </Tag>
                );
              })}
          </div>

          
          <Table
            rowSelection={false}
            className="mt-[1.31rem] w-full"
            scroll={{
              x: "auto",
            }}
            rowKey={(record) => record?.damId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={saving}
        content={
          selectedItem === "ARCHIEVE"
            ? "Are you sure you want to archieve this job"
            : selectedItem === "END_PROCESS"
            ? "Are you sure you want to end recruitment process for this job"
            : null
        }
        type="alert"
        btnTitle="Confirm"
      />
    </>
  );
}

export default JobsTable;
